import { UUID } from "../generic/uuid";
import {
  createSupplierDtoFromAdminSupplierModel,
  SupplierModel,
} from "./supplier";
import { createSellerDtoFromAdminSellerModel, SellerModel } from "./seller";
import {
  createVintageProductDtoFromAdminVintageProductModel,
  VintageProductModel,
} from "./vintageProduct";
import { createPriceDtoFromAdminPriceModel, PriceModel } from "./price";
import { createUploadDtoFromAdminUploadModel, UploadModel } from "./upload";
import { PackageEnum } from "@vini-wine/core-enums";
import { CountryModel, createCountryDtoFromAdminCountryModel } from "./country";
import { OfferDto, VintageProductDto } from "@vini-wine/core-dtos";

export interface OfferModel extends UUID {
  // default includes
  price: PriceModel | null;

  // available includes
  supplier?: SupplierModel | null;
  seller?: SellerModel;
  vintageProducts?: VintageProductModel[];
  upload?: UploadModel;
  shippedFromCountry?: CountryModel | null;

  // transform
  quantity: number;
  package: PackageEnum | null;
  createdAt: Date;
}

export const createOfferDtoFromAdminOfferModel = (
  offer: OfferModel,
): OfferDto => {
  const vintageProducts: VintageProductDto[] = [];
  if (offer.vintageProducts && offer.vintageProducts.length) {
    for (let i = 0; i < offer.vintageProducts.length; i += 1) {
      vintageProducts.push(
        createVintageProductDtoFromAdminVintageProductModel(
          offer.vintageProducts[i],
        ),
      );
    }
  }

  return {
    uuid: offer.uuid,
    createdAt: offer.createdAt,
    package: offer.package,
    price: offer.price ? createPriceDtoFromAdminPriceModel(offer.price) : null,
    quantity: offer.quantity,
    seller: offer.seller
      ? createSellerDtoFromAdminSellerModel(offer.seller)
      : undefined,
    supplier: offer.supplier
      ? createSupplierDtoFromAdminSupplierModel(offer.supplier)
      : undefined,
    shippedFromCountry: offer.shippedFromCountry
      ? createCountryDtoFromAdminCountryModel(offer.shippedFromCountry)
      : undefined,
    vintageProducts,
    upload: offer.upload
      ? createUploadDtoFromAdminUploadModel(offer.upload)
      : undefined,
  };
};
